"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientEvent = void 0;
exports.ClientEvent = {
    ConversationInitiationMetadata: "conversation_initiation_metadata",
    AsrInitiationMetadata: "asr_initiation_metadata",
    Ping: "ping",
    Audio: "audio",
    Interruption: "interruption",
    UserTranscript: "user_transcript",
    AgentResponse: "agent_response",
    AgentResponseCorrection: "agent_response_correction",
    ClientToolCall: "client_tool_call",
    InternalVadScore: "internal_vad_score",
    InternalTurnProbability: "internal_turn_probability",
    InternalTentativeAgentResponse: "internal_tentative_agent_response",
};
